const resultFunction = (
  country,
  getProviderAvailability,
  isAssetBuyIntersection,
  isAssetSellIntersection,
  isEnabled,
  user
) =>
  (isAssetBuyIntersection || isAssetSellIntersection) &&
  Boolean(country?.isSupported) &&
  Object.values(getProviderAvailability).some(
    (enabled) => enabled === true || enabled?.buy === true || enabled?.sell === true
  ) &&
  isEnabled &&
  user.authenticated

const isOnSelectorDefinition = {
  id: 'isOn',
  resultFunction,
  dependencies: [
    { selector: 'country' },
    { selector: 'getProviderAvailability' },
    { selector: 'isAssetBuyIntersection' },
    { selector: 'isAssetSellIntersection' },
    { selector: 'isEnabled' },
    { selector: 'user' },
  ],
}

export default isOnSelectorDefinition
